import { useLocation, useNavigate, useParams } from "react-router-dom";

import { Box, Typography } from "@mui/material";

import { ReactComponent as IconArrowLeft } from "assets/svg/20-arrow-left.svg";
import ReportDetail from "./component/detail";
import OtherReport from "./component/otherReports";
import { BackWrapper, Detail, DetailReportWrapper } from "./styles";

const DetailReportPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const baseUrl = location.pathname.replace(`/${id}`, "");
  return (
    <DetailReportWrapper>
      <Box width={90} className="back">
        <BackWrapper onClick={() => navigate(baseUrl)}>
          <IconArrowLeft />
          <Typography
            variant="subtitle1"
            sx={({ palette }) => ({
              whiteSpace: "nowrap",
              color: palette.colorsBase.blue_0,
              fontWeight: 500,
            })}
          >
            <Typography>Trở lại</Typography>
          </Typography>
        </BackWrapper>
      </Box>
      <Detail>
        <ReportDetail />
        <OtherReport />
      </Detail>
    </DetailReportWrapper>
  );
};

export default DetailReportPage;
